module.exports = __webpack_public_path__ + "static/img/guide-11.3a110a7c.png";